import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Welcome from './components/Welcome/Welcome';
import SiteBackground from './components/SiteBackground/SiteBackground';
import AudioToggle from './components/AudioToggle/AudioToggle';

import './App.css';

// import Home from './containers/Home/Home';

const HomePromise = import('./containers/Home/Home');
const Home = React.lazy(() => HomePromise);
const WorkDetail = React.lazy(() => import('./containers/Works/WorkDetail/WorkDetail'));

class App extends Component {

  constructor(props) {
    super(props);
    this.iResolution = {
      w: window.innerWidth,
      h: window.innerHeight
    }
  }

  state = {
    isResized: false,
    isLoading: true
  }

  componentDidMount() {
    // window.addEventListener('resize', this.resizeHandler);
  }

  componentDidUpdate() {
    // this.setState({ isMounted: true });
    // console.log('lol' + performance.now())
  }


  setLoaded = () => {
    this.setState({ isLoading: false });
    // window.location.reload();
  }

  render() {
    return (
      <BrowserRouter>
        <SiteBackground>
          <React.Suspense fallback={<Welcome />}>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/work/:slug" render={(routeProps) => (
                <WorkDetail key={routeProps.match.params.slug} {...routeProps} />
              )} />
            </Switch>
          </React.Suspense>
          {/* Global audio control — lives outside Suspense so it persists
              across route transitions and stays clickable on every page. */}
          <AudioToggle />
          {/* Procedural grain overlay (Phase 2). Fixed, non-interactive, low in
              the stack — textures the dark background without touching UI/text.
              Styled in App.css (#GrainOverlay). */}
          <div id="GrainOverlay" aria-hidden="true" />
        </SiteBackground>
      </BrowserRouter>
    );
  }
}

export default App;
